import React from 'react';
import { Box, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import { BottomSheet } from 'react-spring-bottom-sheet';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-spring-bottom-sheet/dist/style.css';

const WrapperContainer = ({
  classes,
  onDismiss,
  isDeviceLgSize,
  children,
  openMobileSummary,
}) => (
  <Grid container className={classes.container}>
    {isDeviceLgSize ? (
      <BottomSheet open={openMobileSummary} onDismiss={onDismiss} className={classes.bottomSheet}>
        <Box p={2} pb={2}>
          {children}
        </Box>
      </BottomSheet>
    ) : (
      children
    )}
  </Grid>
);

WrapperContainer.propTypes = {
  classes: PropTypes.shape({
    bottomSheet: PropTypes.string,
    container: PropTypes.string,
  }).isRequired,
  children: PropTypes.node.isRequired,
  openMobileSummary: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  isDeviceLgSize: PropTypes.bool.isRequired,
};

export default WrapperContainer;
